module.exports = __webpack_public_path__ + "img/guide-student4.a1f336f6.png";